import { Maybe } from '@oneaudi/onegraph-client';
import { CarConfiMarketConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { Price, PriceFragment, PriceSummaryQuery } from '../__generated__/graphql';

export function mapPriceSummary(
	response: PriceSummaryQuery,
	config: CarConfiMarketConfiguration,
	monthlyRate: Maybe<Price> | undefined,
) {
	const totalPriceFrom = config.uiPreferences?.prices?.totalPriceFrom ?? 'total';

	return {
		parts: response.priceSummary.prices?.priceParts,
		totalPrice: response.priceSummary.prices?.priceParts.find((part) => part.type === totalPriceFrom)?.price,
		monthlyRate: monthlyRate?.value,
		priceDate: response.priceSummary.prices?.priceDate,
	};
}

export type PriceSummary = ReturnType<typeof mapPriceSummary>;

export type PriceOrError = PriceFragment;

/** @deprecated  Avoid using this type, components should handle error case. */
export type PriceInfo = Exclude<PriceOrError, { __typename: 'FinancingError' }>;
